import { UserSession } from "types";
import { useOutletContext } from "react-router-dom";


export default function useUserSessionOutletContext() {
  return useOutletContext<{ user: UserSession; searchRef: any }>();
}
